<template>
    <v-layout align-center justify-center row wrap class="social-container">
        <v-flex xs12 sm6 class="pa-2">
            <v-btn @click="redirectFacebook" block depressed class="facebook" color="#587cbf">
                <v-icon>fab fa-facebook-f</v-icon>
                Facebook prijava
            </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2 right">
            <v-btn @click="redirectGoogle" block depressed class="gmail" color="#d54b37">
                <v-icon>fab fa-google-plus-g</v-icon>
                Google+ prijava
            </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <v-btn @click="redirectApple" block depressed class="apple" color="#000000">
            <v-icon>fab fa-apple</v-icon>
            Apple prijava
          </v-btn>
        </v-flex>
      <v-flex xs12 sm6 class="pa-2 right">
        &nbsp;
      </v-flex>
    </v-layout>
</template>

<script>
    import utils from "../store/utils";


    export default {
        name: "SocialLogin",
        props: {
          redirect: undefined,
        },
        computed: {
            fbLogin: utils.vuexBuildSetGet(this, 'application', 'urls.login.fb'),
            googleLogin: utils.vuexBuildSetGet(this, 'application', 'urls.login.google'),
            appleLogin: utils.vuexBuildSetGet(this, 'application', 'urls.login.apple'),
            redirectAppend() {
              if (this.redirect) {
                return '?next=' + this.redirect
              }
              return '';
            }
        },
        methods: {
            redirectFacebook(){
                this.$store.dispatch('application/redirect', {
                    url: this.fbLogin + this.redirectAppend,
                    message: 'Preusmerjamo vas na Facebook za izvedbo prijave....'
                }, {root: true})
            },
            redirectGoogle(){
                this.$store.dispatch('application/redirect', {
                    url: this.googleLogin + this.redirectAppend,
                    message: 'Preusmerjamo vas na Google za izvedbo prijave....'
                }, {root: true})
            },
            redirectApple(){
              this.$store.dispatch('application/redirect', {
                url: this.appleLogin + this.redirectAppend,
                message: 'Preusmerjamo vas na Apple za izvedbo prijave....'
              }, {root: true})
            }
        }
    }
</script>

<style scoped>

    .social-container {
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .facebook, .gmail, .apple {
        color: white !important;
        text-transform: initial;
    }

    .v-icon {
        margin-right: 10px;
    }

    .right {
        text-align: right;
    }

</style>